import React from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {FaYoutube} from '@react-icons/all-files/fa/FaYoutube';
import {FaFacebook} from '@react-icons/all-files/fa/FaFacebook';
import {FaTwitter} from '@react-icons/all-files/fa/FaTwitter';
import {FaInstagram} from '@react-icons/all-files/fa/FaInstagram';
import {FaLinkedin} from '@react-icons/all-files/fa/FaLinkedin';

const images = {normal: require("../assets/logo-white.png"), scroll: require("../assets/logo-sm-light.png")};

function Footer() {
    const socialMediaLinks = [
        {
            id: '0',
            name: 'Facebook',
            icon: <FaFacebook/>,
            url: 'https://www.facebook.com/geoticket.it/',
            ariaLabel: 'Learn more about us on Facebook!'
        },
        {
            id: '1',
            name: 'Instagram',
            icon: <FaInstagram/>,
            url: 'https://www.instagram.com/geoticket/',
            ariaLabel: 'Learn more about us on Instagram!'
        },
        {
            id: '2',
            name: 'Youtube',
            icon: <FaYoutube/>,
            url: 'https://www.youtube.com/channel/UCpbUHgt3EOUKw0U7CqwARUw',
            ariaLabel: 'Learn more about us on Youtube!'
        },
        {
            id: '3',
            name: 'Twitter',
            icon: <FaTwitter/>,
            url: 'https://twitter.com/geoticket',
            ariaLabel: 'Learn more about us on Twitter!'
        },
        {
            id: '4',
            name: 'LinkedIn',
            icon: <FaLinkedin/>,
            url: 'https://www.linkedin.com/company/geoticket/',
            ariaLabel: 'Learn more about us on LinkedIn!'
        }
    ];

    return (
        <div className="footer">
            <div className="container">
                <Row>
                    <Col xs={12} md={3}>
                        <a href={"/"}><img className={"footer-logo"} src={images.normal} alt=""/></a>
                    </Col>
                    <Col xs={12} md={3}>
                        <ul>
                            <li><a href={"#"}>Chi siamo</a></li>
                            <li><a href={"#"}>Contatti</a></li>
                            <li><a href={"#"}>Ottieni l'App</a></li>
                        </ul>
                    </Col>
                    <Col xs={12} md={3}>
                        <ul>
                            <li><a href={"#"}>Informazioni Societarie</a></li>
                            <li><a href={"#"}>Privacy</a></li>
                            <li><a href={"#"}>Cookies</a></li>
                        </ul>
                    </Col>
                    <Col xs={12} md={3}>
                        <ul className={"social-media"}>
                            {socialMediaLinks.map(link => (
                                <li key={link.id}><a href={link.url}>{link.icon}</a></li>
                            ))}
                        </ul>
                    </Col>
                </Row>
            </div>
            <div className="container">
                <span
                    className={"site-copyright"}>Geoticket S.R.L.@{new Date().getFullYear()} Tutti i diritti riservati</span>
            </div>
        </div>
    );
}

export default Footer;